import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useCalculationFields } from "@ploy-lib/calculation";
import clsx from "clsx";
addRegisteredSectionLayout({
    name: "SummarySection",
    displayName: "SummarySection",
    settings: {
        editableOptions: {}
    }
});
const useStyles = makeStyles((theme) => ({
    root: {
        margin: "0 auto",
        padding: theme.spacing(1),
        maxWidth: "550px"
    }
}), { name: "DploySummarySection" });
export function SummarySection(props) {
    const { allFields = [], className } = props;
    const calculationFields = useCalculationFields(...allFields.map(f => ({ name: f.name, namespace: f.namespace })));
    const classes = useStyles(props);
    return (_jsxs(Grid, { container: true, item: true, xs: 2, className: clsx(className, classes.root), children: [_jsxs(Grid, { item: true, xs: 12, children: [_jsx(Typography, { variant: "caption", children: allFields[0]?.label }), _jsxs(Grid, { container: true, alignItems: "flex-end", style: { paddingTop: "6px" }, children: [_jsx(Typography, { variant: "h2", children: calculationFields[0]?.fieldValue }), _jsx(Typography, { children: "\u00A0" }), _jsx(Typography, { children: allFields[0]?.suffix })] })] }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "body2", children: calculationFields.map((x, i, fields) => {
                        if (i === 0)
                            return "";
                        const fieldValue = x?.fieldValue;
                        if (fieldValue === undefined)
                            return "";
                        let splitter = ", ";
                        if (i + 1 === fields.length)
                            splitter = "";
                        let suffix = allFields[i]?.suffix;
                        if (suffix === undefined)
                            suffix = "";
                        let label = " " + allFields[i]?.label;
                        if (suffix === undefined)
                            label = "";
                        return String(fieldValue + suffix + label + splitter);
                    }) }) })] }));
}
//# sourceMappingURL=SummarySection.js.map